import { Entity } from "@hds/entity-lib";

class UserResearchEntity extends Entity {
    static DEFAULT_DOCUMENT = {};
    constructor(entityPersistence, seedData = {}, options = {}) {
        super(entityPersistence, seedData, options);
        this._virtualDataModel.fromJSON({
            ...UserResearchEntity.DEFAULT_DOCUMENT,
            ...seedData
        });
    }
    /*****************************************************/
    // START ENTITY DATA MODEL
    /*****************************************************/
    get userId() {
        return this._virtualDataModel.getProperty('userId');
    }
    set userId(newUserId) {
        return this._virtualDataModel.setProperty('userId', newUserId);
    }
    get saleListingId() {
        return this._virtualDataModel.getProperty('saleListingId');
    }
    set saleListingId(newSaleListingId) {
        return this._virtualDataModel.setProperty('saleListingId', newSaleListingId);
    }
    get targetPrice() {
        return this._virtualDataModel.getProperty('targetPrice');
    }
    set targetPrice(newTargetPrice) {
        return this._virtualDataModel.setProperty('targetPrice', newTargetPrice);
    }
    get notes() {
        return this._virtualDataModel.getProperty('notes');
    }
    set notes(newNotes) {
        return this._virtualDataModel.setProperty('notes', newNotes);
    }
    /*****************************************************/
    // END ENTITY DATA MODEL
    // START OVERRIDDEN METHODS
    /*****************************************************/
    clone() { throw new Error('METHOD_NOT_ALLOWED'); }
    /*****************************************************/
    // END OVERRIDDEN METHODS
    /*****************************************************/
}

//META PROPERTIES
Object.defineProperty(UserResearchEntity.prototype, '_meta', {
    value: {
        storeName: 'event-runtime-tools',
        entityName: 'user-research'
    }
}, { enumerable: false, configurable: false, writable: false, value: "static" });

export { UserResearchEntity };
export default UserResearchEntity;